import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Observable, Subject } from "rxjs";
import { filter, switchMap, takeUntil } from "rxjs/operators";
import { AddOtherAddressComponent } from "src/app/components/add-other-address/add-other-address.component";
import { EditWarehouseComponent } from "src/app/modules/settings/edit-warehouse/edit-warehouse.component";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { ConfirmDialogComponent } from "../dialogs/confirm-dialog/confirm-dialog.component";

@Component({
  selector: "app-plan-shipment-header",
  templateUrl: "./plan-shipment-header.component.html",
  styleUrls: ["./plan-shipment-header.component.scss"],
})
export class PlanShipmentHeaderComponent implements OnInit,OnDestroy {
  @Input() warehouse;
  @Input() planShipmentForm;
  @Input() warehouse$;
  @Input() isWalmart = false;
  @Input() selectedFbaType;
  private destroy$ = new Subject<void>();
  @Output() warehouseEvent: EventEmitter<any> = new EventEmitter();
  @Output() warehouseId: EventEmitter<any> = new EventEmitter();
  @Output() targetFCEvent: EventEmitter<any> = new EventEmitter();
  @Output() selectedAddressEvent: EventEmitter<any> = new EventEmitter();
  WhsByCity = new FormControl(null);
  targetFCControl = new FormControl(null);
  filteredOptions: any[] = [];
  targetFulfilmentCentres: any[] = [];
  selectedAddress;
  locationRecommendations: any[] = [];
  filteredOptions2: any[] = [];
  targetFulfilmentCentresList:any[]=[]
  activeTab:string = "Random Address";
  constructor(
    private dialog: MatDialog,
    private shipyardService: ShipyardService,
    private snackbar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.WhsByCity.valueChanges
      .pipe(
        switchMap((value) => {
          var result = this.shipyardService.TypeaheadFcs(
            value?.toString(),
            this.planShipmentForm.get("fromWareHouseId").value?.warehouseId,
            (this.selectedFbaType && this.selectedFbaType !== 'All' && this.activeTab == 'Target Fulfilment Center') ? this.shipyardService.getShipmentTypeId(this.selectedFbaType) : null
          );
          return result;          
        })
      )
      .subscribe((res: any) => {
        res.forEach((r: any) => (r.fulfillmentCenterId = r.id)); 
        this.filteredOptions = res;        
      });

    this.planShipmentForm
      .get("fromWareHouseId")
      .valueChanges.pipe(
        switchMap((value) => {
          return this.shipyardService.TypeaheadFcs(
            this.WhsByCity.value || "",
            this.planShipmentForm.get("fromWareHouseId").value?.warehouseId,
            (this.selectedFbaType && this.selectedFbaType !== 'All' && this.activeTab == 'Target Fulfilment Center') ? this.shipyardService.getShipmentTypeId(this.selectedFbaType) : null
          );
        })
      )
      .subscribe((res: any) => {
        res.forEach((r: any) => (r.fulfillmentCenterId = r.id));   
        this.filteredOptions = res;    
        this.filteredOptions2 = res;
        this.clear();
       if(this.planShipmentForm.get("fromWareHouseId").value?.warehouseId) this.getFCForWarehouse();
      });

    this.targetFCControl.valueChanges
      .pipe(
        switchMap((value) => {
          if (value && typeof(value) !== 'object') {
            return this.shipyardService.TypeaheadFcs(
              value?.toString(),
              this.planShipmentForm.get("fromWareHouseId").value?.warehouseId,
              (this.selectedFbaType && this.selectedFbaType !== 'All' && this.activeTab == 'Target Fulfilment Center') ? this.shipyardService.getShipmentTypeId(this.selectedFbaType) : null
            );
          } else {
            this.targetFulfilmentCentres=[];
            this.targetFulfilmentCentres.push(...this.targetFulfilmentCentresList,...this.filteredOptions);
            let e = [];
            return e;
          }
        })
      )
      .subscribe((res: any) => {
        res.forEach((r: any) => (r.fulfillmentCenterId = r.id));
        this.filteredOptions2 = res;
        if(this.planShipmentForm.get("fromWareHouseId").value?.warehouseId) this.getFCForWarehouse(typeof(this.targetFCControl.value) == 'string' ? this.targetFCControl.value : "");
      });
  }

  clear(){
    this.targetFCControl.setValue("");
    this.locationRecommendations = [];
    this.targetFulfilmentCentres = [];
    this.targetFulfilmentCentresList=[];
    this.selectedAddress=null
    this.selectedAddressEvent.emit(null);
    this.targetFCEvent.emit(null);
  }

  getLocationRecommendations() {
    let shipmentType=null;
    if(this.selectedFbaType && this.selectedFbaType !== 'All'){
      shipmentType = this.shipyardService.getShipmentTypeId(this.selectedFbaType)
    } 
    this.shipyardService
      .getLocationRecommendations(
        (this.targetFCControl.value?.fulfillmentCenterId).trim(),shipmentType
      )
      .subscribe({
        next: (res: any) => {
          this.locationRecommendations = res;
          this.locationRecommendations.forEach((res,i)=>{
            res.displayName = 'Option-'+(i + 1)
          })
          if(res?.length) {
            this.selectedAddress=res[0];
            this.selectedAddressEvent.emit(this.selectedAddress);
          }
        },
        error: (err) => {
          this.snackbar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: err.error?.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
        },
      });
    }

  getFCForWarehouse(qry?) {
    if(!this.targetFulfilmentCentresList?.length){
      this.shipyardService
      .getFCForWarehouse(
        this.planShipmentForm.get("fromWareHouseId").value?.warehouseId,
       (this.selectedFbaType && this.selectedFbaType !== 'All') ? this.shipyardService.getShipmentTypeId(this.selectedFbaType) : null)
      .subscribe({
        next: (res: any) => {
          res.forEach(
            (r: any) => (r.isFavourite = true)
          );
          if(qry){
            res=res?.filter(r=>r.fulfillmentCenterId.toLowerCase().includes(qry.toLowerCase()));
          } else{
            this.targetFulfilmentCentresList=Object.assign([],res);
          }
          this.targetFulfilmentCentres = res;         
          this.targetFulfilmentCentres.push(...this.filteredOptions2);
        },
        error: (err) => {
          this.snackbar.openFromComponent(SnackbarComponent, {
            duration: 3000,
            horizontalPosition: "center",
            data: {
              title: err.error?.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
        },
      });
    } else{
      if(qry){
        this.targetFulfilmentCentres=this.targetFulfilmentCentresList?.filter(r=>r.fulfillmentCenterId.toLowerCase().includes(qry.toLowerCase()));
      } else{
        this.targetFulfilmentCentres=this.targetFulfilmentCentresList;
      }
      this.targetFulfilmentCentres.push(...this.filteredOptions2);
    }
  }

  addFavoriteFC(event, fc) {
    event.preventDefault();
    event.stopPropagation();
    fc.disableButton = true;
    const payload = {
      fulfillmentCenterID: fc.fulfillmentCenterId,
      warehouseId:
        this.planShipmentForm.get("fromWareHouseId").value?.warehouseId,
    };
    this.shipyardService
      .addFavoriteFC(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          fc.disableButton = false;
          this.targetFulfilmentCentresList=[];
          this.getFCForWarehouse();
           this.snackbar.openFromComponent(SnackbarComponent, {
              duration: 3000,
              horizontalPosition: "center",
              data: {
                title: "Favorite FC has been added successfully.",
                action: "Dismiss",
                type: "success",
              },
          });
        },
        error: (err) => {
          fc.disableButton = false;
          this.snackbar.openFromComponent(SnackbarComponent, {
            duration: 30000,
            horizontalPosition: "center",
            data: {
              title: err.error?.error[0],
              action: "Dismiss",
              type: "error",
            },
          });
        },
      });
  }

  deleteFavoriteFC(event, fc) {
    event.preventDefault();
    event.stopPropagation();
    fc.disableButton = true;
          const payload = {
            favoriteFCId: fc.favoriteFCId,
          };
          this.shipyardService
            .deleteFavoriteFC(payload).pipe(takeUntil(this.destroy$))
            .subscribe({
              next: (e) => {
                fc.disableButton = false;
                this.targetFulfilmentCentresList=[];
                this.getFCForWarehouse()
                this.snackbar.openFromComponent(SnackbarComponent, {
                  duration: 3000,
                  horizontalPosition: "center",
                  data: {
                    title: "Favorite FC has been deleted successfully.",
                    action: "Dismiss",
                    type: "success",
                  },
                });
              },
              error: (err) => {
                fc.disableButton = false;
                this.snackbar.openFromComponent(SnackbarComponent, {
                  duration: 4000,
                  horizontalPosition: "center",
                  data: {
                    title: err.error?.error[0],
                    action: "Dismiss",
                    type: "error",
                  },
                });
              },
      });
  }

  public createNewWarehouse(type?: any, data?: any) {
    this.dialog
      .open(EditWarehouseComponent, {
        height: "auto",
        width: "500px",
        maxHeight: "90%",
        data: { ...{ type }, ...data },
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res) this.warehouseEvent.next(true);
      });
  }

  openOtherAddressPopup() {
    let currentWarehouse = this.planShipmentForm.get("fromWareHouseId").value;
    this.dialog
      .open(AddOtherAddressComponent, {
        width: "600px",
        data: currentWarehouse,
      })
      .afterClosed()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res) this.warehouseEvent.next(true);
      });
  }

  displayWith(value: any) {
    if (value) {
      return value.city  + " " + "("+value.state + ", " + value.zip +")";
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  
  fcdisplayWith(value: any) {
    if (value) {
      return value.fulfillmentCenterId  + " " + "("+value.state + ", " + value.zip +")";
    }
  }

  onTabChanged(event){
    this.activeTab = event.tab.textLabel;
    if(event.index == 1){
      this.WhsByCity.setValue("");  
      this.warehouseId.emit("");    
    } else{
      this.targetFCControl.setValue("");
      this.selectedAddress=null;
      this.selectedAddressEvent.emit(null);
      this.targetFCEvent.emit(null);
    }
  }

  targetSelected(){
    this.getLocationRecommendations();
    this.targetFCEvent.emit(this.targetFCControl.value);
  }

  randomSelected(){
    this.warehouseId.emit(this.WhsByCity.value);
  }

  onChange(event){
    this.selectedAddressEvent.emit(event);
  }
}
